/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NewsApiModel } from './news';
import { PaymentInfoApiModel } from './payment-info';
import { OrderApiModel } from './order';
import { CouponApiModel } from './coupon';
import { LoyaltyApiModel } from './loyalty';
import { FeedbackSourceApiModel } from './feedback-source';

export interface MessageApiModel {
  /**
   * Attachment type
   */
  attachment?: MessageApiModelAttachmentEnum;
  coupon?: CouponApiModel;
  /**
   * News date
   */
  created?: string;
  dst_loyalty?: LoyaltyApiModel;
  dst_type?: MessageApiModelDstTypeEnum;
  feedback_source?: FeedbackSourceApiModel;
  /**
   * Message ID
   */
  id?: string;
  /**
   * Message body
   */
  message?: string;
  news?: NewsApiModel;
  order?: OrderApiModel;
  outcome?: boolean;
  payment?: PaymentInfoApiModel;
  readed?: number;
  src_loyalty?: LoyaltyApiModel;
  src_type?: MessageApiModelSrcTypeEnum;
  /**
   * Subject of message
   */
  title?: string;
  type?: MessageApiModelTypeEnum;
}
export enum MessageApiModelAttachmentEnum {
  Image = 'image',
  Coupon = 'coupon',
  News = 'news',
  Payment = 'payment',
  FeedbackSource = 'feedback-source',
  OnlineStoreOrder = 'online-store-order'
}
export enum MessageApiModelDstTypeEnum {
  System = 'system',
  Business = 'business',
  User = 'user'
}
export enum MessageApiModelSrcTypeEnum {
  System = 'system',
  Business = 'business',
  User = 'user'
}
export enum MessageApiModelTypeEnum {
  Sms = 'sms',
  Push = 'push',
  Viber = 'viber',
  Email = 'email',
  IncustMessenger = 'incust-messenger',
  IncustChatbot = 'incust-chatbot',
  ExternalSystem = 'external-system',
  PkpassMessage = 'pkpass-message'
}
